export default {
  data: () => ({
    modalDetailsRefuseInsurance: false,
    itemDetailsRefuseInsurance: null
  }),
  methods: {
    showModalDetailsRefuseInsurance(item) {
      this.itemDetailsRefuseInsurance = item;
      this.modalDetailsRefuseInsurance = true;
    },
    closeModalDetailsRefuseInsurance() {
      this.itemDetailsRefuseInsurance = null;
      this.modalDetailsRefuseInsurance = false;
    }
  }
};
